import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnInit,
  Optional,
  ViewChild
} from '@angular/core';
import { DropdownTriggerDirective } from '../dropdown/dropdown-trigger.directive';
import { IconTypes } from '../svg-icon/icon-types';

@Component({
  selector: 'mtg-button',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent implements OnInit {
  @Input()
  color: 'primary' | 'secondary';
  @Input()
  size: 'lg' | 'md' | 'sm';
  @Input()
  variant: 'button' | 'circle' | 'link' | 'label' | 'outline';
  @Input()
  leadingIcon: IconTypes;
  @Input()
  trailingIcon: IconTypes;
  @Input()
  type = 'button';
  @Input()
  href: string;
  @Input()
  target = 'self';
  @Input()
  fluid: boolean;
  @Input()
  disabled: boolean;
  dropdownVisible: boolean;

  @ViewChild('linkElement', {read: ElementRef})
  linkElement: ElementRef;

  @HostBinding('class.button--fluid')
  get classButtonFluid() {
    return this.fluid;
  }

  get class(): string {
    const classes = ['button'];
    if (this.color === 'secondary') {
      classes.push('button--color-secondary');
    } else {
      classes.push('button--color-primary');
    }

    if (this.size === 'lg') {
      classes.push('button--size-lg');
    } else if (this.size === 'sm') {
      classes.push('button--size-sm');
    } else {
      classes.push('button--size-md');
    }

    if (this.variant === 'circle') {
      classes.push('button--variant-circle');
    } else if (this.variant === 'link') {
      classes.push('button--variant-link');
    } else if (this.variant === 'outline') {
      classes.push('button--variant-outline');
    } else {
      classes.push('button--variant-button');
    }
    if (this.dropdown) {
      classes.push('button--dropdown');
      if (this.dropdownVisible) {
        classes.push('button--dropdown-opened');
      }
    }
    if (this.fluid) {
      classes.push('button--fluid');
    }
    if (this.disabled) {
      classes.push('button--disabled');
    }

    return classes.join(' ');
  }

  constructor(
    @Optional() private dropdown: DropdownTriggerDirective,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    if (this.dropdown) {
      this.dropdown.isVisible$.subscribe(isVisible => {
        this.dropdownVisible = isVisible;
        this.cdr.markForCheck();
      });
    }
  }

  get hasDropdown(): boolean {
    return Boolean(this.dropdown) && this.variant !== 'circle';
  }
}
